module.exports = __webpack_public_path__ + "img/log.58871b11.png";